import { Button, IconButton, Stack, Typography } from "@mui/material";
import { useCallback, useMemo, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import Loading from "src/components/Loading/Loading";
import PaymentMethod from "./components/PaymentMethod";
import AddNewPayment from "./components/AddNewPayment";
import { useIsMobile } from "src/hooks/useIsMobile";
import { KeyboardBackspace } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useGetPaymentMethodsQuery } from "src/api/services/paymentMethodsApi";
import { useTranslation } from "react-i18next";
import StripeContextProvider from "src/context/StripeContext";

const PaymentMethods = () => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const { data: paymentMethods, isLoading: isMethodsLoading } =
    useGetPaymentMethodsQuery();
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const page = "payment-methods";

  const handleOpen = useCallback(() => {
    setOpen((o) => !o);
  }, []);

  const methods = useMemo(() => {
    if (paymentMethods == null) return [];

    return paymentMethods;
  }, [paymentMethods]);

  const canDelete = useMemo(() => methods.length > 1, [methods.length]);

  return (
    <>
      <Stack gap="16px" width="100%">
        <Stack direction="row" alignItems="center" gap="16px">
          {isMobile ? (
            <IconButton sx={{ color: "#00B6B8" }} onClick={() => navigate(-1)}>
              <KeyboardBackspace fontSize="large" />
            </IconButton>
          ) : null}
          <Typography variant="h5" fontWeight={700} role="heading">
            {t(`${page}.header`, "Payment Methods")}
          </Typography>
          {isMobile ? null : (
            <Button onClick={handleOpen} startIcon={<AddIcon />} variant="text">
              {t(`${page}.add`, "Add New")}
            </Button>
          )}
        </Stack>
        {isMethodsLoading ? (
          <Loading />
        ) : (
          <Stack
            display={methods.length > 0 ? "inherit" : "none"}
            role="list"
            maxHeight="600px"
            gap="16px"
            overflow="auto"
            padding="5px"
            sx={{
              boxShadow: "0px 3px 17px 0px rgba(0, 0, 0, 0.10)",
              borderRadius: "8px",
            }}
          >
            {methods.map((method) => (
              <PaymentMethod
                key={method.id}
                method={method}
                canDelete={canDelete}
              />
            ))}
          </Stack>
        )}
        {isMobile ? (
          <Button onClick={handleOpen} startIcon={<AddIcon />} variant="text">
            {t(`${page}.add`)}
          </Button>
        ) : null}
      </Stack>
      <StripeContextProvider>
        <AddNewPayment onClose={handleOpen} open={open} />
      </StripeContextProvider>
    </>
  );
};

export default PaymentMethods;
